<button
  mat-stroked-button
  [matMenuTriggerFor]="decisionMenu"
  [disabled]="survey?.is_revised"
  class="final-decision-selector-btn"
  [class.selector-empty]="!selectedStatus"
  [class.selector-filled]="!!selectedStatus"
  [ngStyle]="selectedStatus ? { 'background-color': selectedStatus.bgcolor, 'color': 'white', 'border-color': selectedStatus.bgcolor } : {}"
>
  @if (selectedStatus) {
    <span class="decision-btn-inner">
      <mat-icon class="decision-btn-icon">{{ selectedStatus.icon }}</mat-icon>
      <span class="decision-btn-label">{{ displayLabel }}</span>
    </span>
  } @else {
    <span class="decision-btn-label">{{ "generic.no-choice" | translate }}</span>
  }
</button>

<mat-menu #decisionMenu="matMenu" class="final-decision-menu">
  @for (status of statuses; track status.id) {
    <button
      mat-menu-item
      (click)="onSelectDecision(status.id)"
      [ngStyle]="{ 'color': status.bgcolor }"
    >
      <mat-icon [style.color]="status.bgcolor">{{ status.icon }}</mat-icon>
      <span>{{ survey?.is_revised ? status.title : status.titleNoRev }}</span>
    </button>
  }
  @if (selectedStatus) {
    <div class="menu-divider"></div>
    <button mat-menu-item (click)="onSelectDecision(null)" class="cancel-decision-item">
      <mat-icon>close</mat-icon>
      <span>{{ "generic.cancel-decision" | translate }}</span>
    </button>
  }
</mat-menu>
